
import { Vue, Component, Prop, Emit, Watch } from "vue-property-decorator"
import api from "../honcierge-api"
import ArticleSearchForm from "@/components/ArticleSearchForm.vue"
import { AxiosError } from "axios"
import { ArticleSearchMaster, SelectedArticle } from "types/index"
import { DataTableHeader } from "vuetify/types"

@Component({
  components: { ArticleSearchForm },
})
export default class SelectRelatedArticle extends Vue {
  get headers(): DataTableHeader[] {
    return [
      { text: "選択", value: "select", sortable: false },
      { text: "ID", value: "id" },
      { text: "タイトル", value: "title" },
      { text: "コンシェルジュ", value: "writer" },
    ]
  }

  get fields(): DataTableHeader["value"][] {
    return this.headers
      .map((header) => header.value)
      .filter((value) => value !== "select")
  }

  @Prop()
  public dialog!: boolean

  private articleSearchMaster: ArticleSearchMaster["searchMaster"] = {
    statuses: [],
    editors: [],
    writers: [],
    categories: [],
    appAffiliates: [],
  }

  private title = ""
  private articles: SelectedArticle[] = []
  private loading = false
  private totalPages = 0
  private pagination = {
    sortBy: ["id"],
    sortDesc: [true],
    itemsPerPage: -1,
    page: 1,
  }
  private candidateArticleMap: Map<number, SelectedArticle> = new Map() // key: id, value: article

  @Emit("ok")
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public ok(selectedArticles: []): void {
    /* */
  }

  @Emit("cancel")
  public cancel(): void {
    /* */
  }

  public clear(): void {
    this.articles = []
    this.resetPagination()
    this.resetSelection()
    const form = this.$refs.articleSearchForm as InstanceType<
      typeof ArticleSearchForm
    >
    form.reset()
  }

  public searchResult(result: SelectedArticle[], totalPages: number): void {
    this.articles = result
    this.totalPages = totalPages
    this.modifySelection(this.articles)
    this.loading = false
  }

  private resetPagination() {
    this.pagination.page = 1
  }

  private resetSelection() {
    this.candidateArticleMap.clear()
  }

  private selected() {
    return Array.from(this.candidateArticleMap.values())
  }
  private toggleCandidateArticle(article: SelectedArticle) {
    if (article.select) {
      this.candidateArticleMap.set(article.id, article)
    } else {
      this.candidateArticleMap.delete(article.id)
    }
  }

  private modifySelection(articles: SelectedArticle[]) {
    articles.forEach((article) => {
      Object.assign(article, {
        select: this.candidateArticleMap.has(article.id),
      })
    })
  }

  @Watch("pagination.page", { deep: true, immediate: true })
  private onChangePage() {
    if (this.dialog) {
      this.loading = true
      setTimeout(() => {
        const articleSearchForm = this.$refs.articleSearchForm as InstanceType<
          typeof ArticleSearchForm
        >
        articleSearchForm.search(this.pagination.page)
        this.loading = false
      }, 500)
    }
  }

  private created() {
    api
      .adminSearchMasters()
      .then((res) => {
        const result = res.data.searchMaster
        this.articleSearchMaster.statuses = result.articleStatuses
        this.articleSearchMaster.editors = result.editors
        this.articleSearchMaster.writers = result.writers
        this.articleSearchMaster.categories = result.categories
        this.articleSearchMaster.appAffiliates = result.appAffiliates
      })
      .catch((e: AxiosError) => {
        console.log(e.stack)
      })
  }
}
